import * as yup from 'yup'
import CustomFieldTypes, { customFieldValidations, requiredValidationFor } from '@/constants/customFieldTypes'

export const customEntityDataSchema = customFields =>
  yup.object().shape({
    customFields: yup.object().shape({
      ...customFields.reduce((acc, customField) => {
        const validation = customFieldValidations(yup)[customField.fieldType]
        if (validation) {
          if (customField.required) {
            const fieldKey = customField.fieldType === CustomFieldTypes.Percent
              ? `___${customField.key}`
              : customField.key

            acc[fieldKey] = requiredValidationFor(validation)
          } else if (customField.fieldType !== CustomFieldTypes.Percent) {
            acc[customField.key] = validation()
          }
        }
        return acc
      }, {}),
    }),
  })
